import { TriangleAlertIcon } from '@ttab/elephant-ui/icons'
import { type JSX } from 'react'
import { useTranslation } from 'react-i18next'

/** The red triangle marking something missing, placed wherever the caller puts it. */
export const ValidationIcon = ({ className }: { className?: string }): JSX.Element => {
  const { t } = useTranslation()

  return (
    <span role='img' aria-label={t('common:misc.missing')} className={className}>
      <TriangleAlertIcon color='red' fill='#ffffff' size={15} strokeWidth={1.75} />
    </span>
  )
}
